import classNames from 'classnames';

interface Props {
  label: string;
  active?: boolean;
  id: string;
  onClick: (id: string) => void;
}

const TierNavigationItem = ({ id, label, active, onClick }: Props) => {
  const handleOnClick = () => {
    onClick(id);
  };

  return (
    <button
      type="button"
      id={`${id}-menu-item`}
      onClick={handleOnClick}
      className={classNames(
        ' h-[48px] flex items-center first:md:pl-4 first:pl-3 pl-2 mr-2 last:md:mr-4 last:mr-3 text-base font-normal relative overflow-hidden whitespace-nowrap text-ellipsis transition-colors',
        {
          'text-neutral-900': active,
          'text-neutral-500': !active
        }
      )}
    >
      {label}
      {active && (
        <div className="h-1 bg-neutral-900 absolute w-full bottom-[8px]" />
      )}
    </button>
  );
};

export default TierNavigationItem;
